'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = exports.HeadingTag = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _verify = require('helpers/verify');

var _DocumentLevel = require('components/CmsPage/modules/DocumentLevel/DocumentLevel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALIGNMENTS = ['left', 'center', 'right'];
var TITLE_SIZES = ['regular', 'medium', 'large', 'huge', 'header-small', 'header', 'header-large', 'display-tiny', 'display-small', 'display', 'display-large'];

var HeadingTag = exports.HeadingTag = function HeadingTag(_ref) {
  var className = _ref.className,
      title = _ref.title;
  return _react2.default.createElement(
    _DocumentLevel.DocumentLevel.Consumer,
    null,
    function (level) {
      var Tag = level > 6 ? 'p' : 'h' + level;
      var tagClass = (0, _classnames2.default)(className, level > 6 && 'h' + level);
      return _react2.default.createElement(
        Tag,
        { className: tagClass },
        title
      );
    }
  );
};

var Heading = exports.Heading = function Heading(_ref2) {
  var _classNames;

  var alignment = _ref2.alignment,
      size = _ref2.size,
      title = _ref2.title;

  if ((0, _verify.isBlank)(title)) {
    return null;
  }

  var headerClasses = (0, _classnames2.default)((_classNames = {
    Heading: true
  }, (0, _defineProperty3.default)(_classNames, 'Heading--align-' + alignment, alignment), (0, _defineProperty3.default)(_classNames, 'Heading--size-' + size, size), _classNames));

  return _react2.default.createElement(
    'header',
    { className: headerClasses },
    _react2.default.createElement(HeadingTag, { className: 'Heading__title', title: title })
  );
};

Heading.defaultProps = {
  alignment: 'center'
};

HeadingTag.propTypes = {
  className: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired
};

Heading.propTypes = {
  alignment: _propTypes2.default.oneOf(ALIGNMENTS),
  size: _propTypes2.default.oneOf(TITLE_SIZES),
  title: _propTypes2.default.string
};